import * as React from 'react';
import styled from 'styled-components';
import { Flex, FlexItem } from './compositeComponents/FlexHelpers';
import { Icon, iconName } from './icons/Icons';
import { Small } from './typography/Body';
import { H1 } from './typography/Heading';
import { rawColors } from './colors/color';

export type PageHeaderProps = {
    headerIcon?:iconName,
    headerText?:string,
    subHeader?:{ icon?:iconName, iconColor?:string, text:string },
    headerContentsOverride?:React.ReactNode,
    buttons?:React.ReactNode,
    narrow?: boolean,
    margin?: string,
}
export function PageHeader(props:PageHeaderProps):JSX.Element
{
    const color = rawColors.gray.normal;

    let headerText:React.ReactNode = 
        <H1 style={{ fontSize:16, color, fontWeight:450}}>
            {props.headerText ||''}
        </H1>;
        
    if(props.headerContentsOverride)
    {
        headerText = props.headerContentsOverride
    }

    return (
        <ContentWrapper narrow={props.narrow} margin={props.margin}> 
            <Flex flexDirection="column" gap={4}>

                <Flex flexDirection="row" justifyContent='space-between' alignItems='flex-end'>
                    <Flex flexDirection='row' gap={16} alignItems='center'>
                        
                        <Flex flexDirection='column' gap={4} alignItems='flex-start'>

                            <Flex flexDirection='row' gap={8} alignItems='center'>
                                {/* {props.headerIcon &&
                                    <Icon name={props.headerIcon} size="small" color={color} />
                                } */}
                                {headerText}
                            </Flex>
                        
                            {props.subHeader && 
                                <Flex gap={8} style={{paddingLeft:'8px'}}>
                                    {props.subHeader.icon &&
                                        <Icon name={props.subHeader.icon} size="x-small" color={props.subHeader.iconColor || color} />
                                    }
                                    <Small>{props.subHeader.text}</Small>
                                </Flex>
                            }
                        </Flex>

                    </Flex>
                    <FlexItem>
                        {props.buttons}
                    </FlexItem>
                </Flex>

            </Flex>
        </ContentWrapper>
    );
}

const ContentWrapper = styled.div<{narrow?: boolean, margin?: string}>`
    width:90%;
    max-width: ${props => props.narrow ? '1020px' : '90%'};
    margin: ${props => props.margin || '16px auto 4px auto'};
    padding:0px;
`;